module.exports = __webpack_public_path__ + "static/media/twelve.e2fa9839.svg";